<template>
  <v-row class="pt-3">
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <v-text-field
        v-model="keywordReqNo"
        chips
        outlined
        label="หมายเลขคำร้องขอ"
        placeholder="ค้นหา หมายเลขคำร้องขอ"
        class="mt-2"
        dense
        v-on:keyup.enter="searchFilterData(), page=1"
      >
      </v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <v-text-field
        v-model="keywordEmployeeName"
        chips
        outlined
        label="ชื่อ-สกุล"
        placeholder="ค้นหา ชื่อ-สกุล"
        class="mt-2"
        dense
        v-on:keyup.enter="searchFilterData(), page=1"
      >
      </v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <v-select
        v-model="keywordReqTyp"
        :items="itemReqType"
        item-text="text"
        item-value="value"
        outlined
        label="ประเภทเอกสาร"
        placeholder="ค้นหา ประเภทเอกสาร"
        class="mt-2"
        dense
      >
      </v-select>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <v-select
        v-model="keywordCompanyName"
        :items="itemCompanyName"
        outlined
        label="ชื่อบริษัท"
        placeholder="ค้นหา ชื่อบริษัท"
        dense
        multiple
        class="mt-2"
      />
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <v-select
        v-model="keywordStatus"
        :items="itemStatus"
        outlined
        label="สถานะ"
        placeholder="ค้นหา สถานะ"
        class="mt-2"
        dense
      >
      </v-select>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <v-select
        v-model="keywordPosition"
        :items="itemPosition"
        outlined
        label="ตำแหน่ง"
        placeholder="ค้นหา ตำแหน่ง"
        class="mt-2"
        dense
      >
      </v-select>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 d-flex align-end" style="padding-bottom: 14px;">
      <v-btn class="btn-search-dep mr-5" style="min-height: 38px;" @click="searchFilterData()">ค้นหา</v-btn>
      <v-btn class="btn-reset-dep" style="min-height: 38px;" @click="resetFilterData()">ล้างข้อมูล</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { EventBus } from '@/EventBus'

export default {
  name: 'filter-workgroup',
  data () {
    return {
      keywordReqNo: '',
      keywordEmployeeName: '',
      keywordReqTyp: [],
      keywordCompanyName: [],
      keywordStatus: [],
      keywordPosition: [],
      keywordUserName: [],
      filterData: {
        name: '',
        header: [],
        companyName: [],
        groupCompany: [],
        limit: 50,
        page: 1
      },
      itemSmall: ['INET', 'OGS'],
      itemLineWorkName: [],
      itemReqType: [],
      itemUserName: [],
      itemGroupCompanyName: [],
      itemCompanyName: [],
      itemPosition: [],
      itemStatus: [],
      itemsSmallDep: [{
        id: 0,
        value: 0,
        label: 'INET'
      }, {
        id: 1,
        value: 1,
        label: 'MANDALA'
      }]
    }
  },
  watch: {
    keywordReqNo: function (val) {
      if (val.length) {
        this.filterData.name = val
        // console.log('Work Name', this.filterData.name)
      }
      // EventBus.$emit('detailCompany', nodeId)
    },
    keywordReqTyp: function (val) {
      if (val.length) {
        this.filterData.managementName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    }
  },
  mounted () {
    EventBus.$on('getEmployee', this.getSelectData)
    EventBus.$on('selectEmployeeApprove', this.getSelectValue)
    EventBus.$on('selectCompany', this.getSelectCompany)
  },
  methods: {
    getSelectCompany (value) {
      this.itemGroupCompanyName = value.groupName
    },
    getSelectValue (value) {
      this.itemReqType = value[0].requestType.map(e => { return (e = { value: e, text: e === 'new' ? 'เพิ่มบุคคล' : e === 'resign' ? 'ลาออก' : e === 'transfer' ? 'ย้ายฝ่าย' : e === 'transferPosition' ? 'ย้ายตำแหน่ง' : e === 'resignEmployee' ? 'ลาออกจากบริษัท' : 'ลาออกจากตำแหน่ง' }) })
      this.itemCompanyName = value[0].companyName
      this.itemPosition = value[0].position
      this.itemStatus = value[0].requestStatus.map(e => { return (e = { value: e, text: e === 'approve' ? 'อนุมัติ' : e === 'reject' ? 'ปฏิเสธการอนุมัติ' : e === 'pending' ? 'รอการอนุมัติ' : e === 'cancel' ? 'ยกเลิก' : 'ยกเลิก' }) })
    },
    getSelectData (data) {
      this.itemSmall = data.companyShortName
      this.itemReqType = data.managementHeader
      this.itemUserName = data.userName
    },
    resetFilterData () {
      this.keywordReqNo = ''
      this.keywordEmployeeName = ''
      this.keywordReqTyp = []
      this.keywordCompanyName = []
      this.keywordUserName = ''
      this.keywordPosition = []
      this.keywordStatus = []
      this.filterData = {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        requestStatus: [],
        position: [],
        requestType: [],
        limit: 50,
        page: 1
      }
      EventBus.$emit('filterEmployeeApprove', this.filterData)
    },
    searchFilterData () {
      this.filterData = {
        reqEmployeeNo: this.keywordReqNo,
        employeeName: this.keywordEmployeeName,
        companyName: this.keywordCompanyName,
        requestStatus: [this.keywordStatus],
        position: [this.keywordPosition],
        requestType: [this.keywordReqTyp],
        limit: 50,
        page: 1
      }
      // console.log('Filter Data Approve', this.filterData)
      EventBus.$emit('filterEmployeeApprove', this.filterData)
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
</style>
